export default "__VITE_ASSET__3b38e096__"